module.exports = __webpack_public_path__ + "static/assets/078fc002c9422410ebe3d4fd73d8639e.png";